/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { Alert, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import "./TrialAlertBanner.css";
import { CommunityOwner } from "../../Utils/Constant";

const TrialAlertBanner = ({
    showAlertBanner,
    setShowAlertBanner,
    daysLeft,
    openModalHandler,
}) => {
    const userType = localStorage.getItem("user_type");
    if (!showAlertBanner) return null;

    return (
        <>
        { daysLeft > 0 ?  <Alert
            className="bg-trial-alert-banner"
            severity="warning"
            action={
                <IconButton
                    aria-label="close"
                    color="inherit"
                    size="small"
                    onClick={() => setShowAlertBanner(false)}
                >
                    <CloseIcon fontSize="inherit" />
                </IconButton>
            }
        >
            {daysLeft > 0 ? (
                userType !== CommunityOwner ? (
                    <>
                        Your trial will expire in <strong>{daysLeft} days</strong>.{" "}
                        <a
                            href="#"
                            onClick={openModalHandler}
                            style={{ color: "inherit", fontWeight: "bold" }}
                        >
                            Subscribe now
                        </a>{" "}
                        to keep enjoying our services.
                    </>
                ) : (
                    <>
                        Your trial will expire in <strong>{daysLeft} days</strong>. Subscribe now to keep enjoying our services.
                    </>
                )
            ) : null}
        </Alert> : null}
       
        </>
    );
};

export default TrialAlertBanner;
